module.exports = __webpack_public_path__ + "static/media/wab32_1016.d9e4f880.ico";